import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface LeftUpperSuspensionCoverProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function LeftUpperSuspensionCover(props: LeftUpperSuspensionCoverProps) {
  return (
    <svg
      width="119"
      height="159"
      viewBox="0 0 119 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 26, left: 258}}
      onClick={props.onClick}
    >
      <path
        d="M2.00337 108.04L2.00336 156.002L2 156.118L86 158C92.7571 158 105.724 156.631 117.866 150.811L118 151.006C117.962 150.939 117.923 150.872 117.885 150.805C102.882 124.622 80 46.0263 80 21.1104C80 11.2403 75.1212 7.22006 70.1829 3.15076L70 3V3.12489C70 31.1024 70 48.0887 26 71.0702C2.16665 83.3222 2.00337 103.044 2.00337 108.04Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M55.0888 140C62.3856 140 69.0334 137.233 74.0303 132.696C75.0853 133.581 76.4484 134.115 77.9363 134.115C81.285 134.115 83.9999 131.412 84 128.079C84 125.861 82.7968 123.924 81.0058 122.876C82.4194 119.537 83.2022 115.868 83.2022 112.018C83.2022 98.6233 73.7455 87.4303 61.1159 84.6839C61.1388 84.4708 61.1525 84.2546 61.1525 84.0355C61.1525 80.7024 58.4374 78.0004 55.0888 78.0001C51.7399 78.0001 49.0252 80.7023 49.0252 84.0355C49.0252 84.2546 49.0367 84.4708 49.0596 84.6839C36.4305 87.4307 26.9754 98.6236 26.9754 112.018C26.9754 115.837 27.7444 119.477 29.1363 122.794C27.267 123.822 26 125.803 26 128.079C26.0001 131.412 28.716 134.115 32.0647 134.115C33.5957 134.115 34.9931 133.548 36.0602 132.617C41.0668 137.201 47.7496 140 55.0888 140Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M117.881 150.799L118 151.006M118 151.006C103 125.027 80 46.0903 80 21.1104C80 11.1185 75 7.12168 70 3V3.12489C70 31.1024 70 48.0887 26 71.0702C2.16665 83.3222 2.00337 103.044 2.00337 108.04L2.00336 156.002L2 156.118C27.3758 156.687 54.1251 157.286 86 158C92.7571 158 105.724 156.631 117.866 150.811L118 151.006Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="22"
        cy="22"
        r="22"
        transform="matrix(1 0 0 -1 33 134)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="10"
        cy="10"
        r="10"
        transform="matrix(1 0 0 -1 45 122)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="3"
        cy="3"
        r="3"
        transform="matrix(1 0 0 -1 52 115)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 76 130)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 30 130)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 53 86.0001)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M55.0888 140C62.3856 140 69.0334 137.233 74.0303 132.696C75.0853 133.581 76.4484 134.115 77.9363 134.115C81.285 134.115 83.9999 131.412 84 128.079C84 125.861 82.7968 123.924 81.0058 122.876C82.4194 119.537 83.2022 115.868 83.2022 112.018C83.2022 98.6233 73.7455 87.4303 61.1159 84.6839C61.1388 84.4708 61.1525 84.2546 61.1525 84.0355C61.1525 80.7024 58.4374 78.0004 55.0888 78.0001C51.7399 78.0001 49.0252 80.7023 49.0252 84.0355C49.0252 84.2546 49.0367 84.4708 49.0596 84.6839C36.4305 87.4307 26.9754 98.6236 26.9754 112.018C26.9754 115.837 27.7444 119.477 29.1363 122.794C27.267 123.822 26 125.803 26 128.079C26.0001 131.412 28.716 134.115 32.0647 134.115C33.5957 134.115 34.9931 133.548 36.0602 132.617C41.0668 137.201 47.7496 140 55.0888 140Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
